import React, { useEffect, useRef, useState } from 'react'
import { Provider } from 'react-redux'
import store from '~/data/store/store'

import LinkPickerComponent from '~/Common-Objects/TemplateEditor/RightTools/ElementEditor/Components/LinkPicker'

const mpLinkPickerDropdown = ({
    onUpdate = () => {},
    onClose = () => {},
    value = '',
    closeExternalPickers = () => {},
    toggleHidePickers = () => {},
    elementsData = [],
    isLandingPage = false
}) => {
    useEffect(() => {}, [])

    async function init() {}

    return (
        <Provider store={store}>
            <div className='templateEditor-redactorplugins-mpLinkPicker'>
                <LinkPickerComponent
                    usePortal={true}
                    save={onUpdate}
                    currVal={value}
                    close={onClose}
                    toggleHidePickers={() => {}}
                    elementsData={elementsData}
                    standalone={false}
                    dropDownStyle={{ maxHeight: 'calc(100vh - 300px)', zIndex: 1600 }}
                    captureClickOutside={true}
                    hideCancelButton={true}
                    showRemoveButton={value && value.length}
                    isLandingPage={isLandingPage}
                />
            </div>
        </Provider>
    )
}

export default mpLinkPickerDropdown
